import React from 'react';

interface MediaQueryProps {
    query: string;
    onChange?: (queryMatches: boolean) => void;
}

export class MediaQuery extends React.Component<MediaQueryProps, {isShown: boolean}> {

    constructor(props: MediaQueryProps) {
        super(props);
        this.state = {
            isShown: false
        };
    }

    private mediaQueryList: MediaQueryList;

    handleQueryBreakpoint = () => {
        if (this.props.onChange) {
            this.props.onChange(this.mediaQueryList.matches);
        }
        this.setState({isShown: this.mediaQueryList.matches});
    }

    componentDidMount(): void {
        this.mediaQueryList = window.matchMedia(this.props.query);
        this.mediaQueryList.addListener(this.handleQueryBreakpoint);

        this.handleQueryBreakpoint();

    }
    componentWillUnmount(): void {
        this.mediaQueryList.removeListener(this.handleQueryBreakpoint);
    }

    render(): JSX.Element | null {
        if (this.state.isShown) {
            return <div>{this.props.children}</div>;
        } else {
            return null;
        }
    }
}
